<template>
  <div class="reportWrapper">
    <div class="report-component" id="tr-leading-indicators-html">
      <h1 class="report-component-title">
        {{ title }}
        <sup v-if="showTrademarkSymbol">™</sup>
      </h1>
      <p class="report-component-section">{{ section }}</p>
      <p class="report-component-date">Published {{ publishDate }}</p>

      <h4 class="margin-top" v-html="cwaData.OverviewHeader"></h4>
      <div class="overview" v-html="cwaData.OverviewText"></div>

      <h4 class="margin-top" v-html="cwaData.ImageHeader"></h4>
      <div class="leading-indicator-image">
        <img :src="cwaData.ImageBase64" alt="Trends Report Image" />
      </div>

      <h4 class="">ABOUT THE REPORT</h4>
      <p class="about-text">
        Following a system of leading indicators produces reliable insights
        pertaining to the future business cycle phases of the economy. Using
        that same system, ITR Economics has accurately forecasted future
        economic conditions and advised clients on how to increase profitability
        and reduce risk since 1948. Our forecast accuracy rating is 94.7% at
        four quarters out.
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TrLeadingIndicatorTemplate',
    components: {},
    props: {
      title: {
        type: String,
        required: true,
      },
      cwaData: {
        type: Object,
        required: true,
      },
      section: {
        type: String,
        required: false,
      },
      publishDate: {
        type: String,
        required: false,
      },
    },
    computed: {
      showTrademarkSymbol() {
        return this.title === 'ITR Retail Sales Leading Indicator' || this.title === 'ITR Leading Indicator';
      },
    },
  };
</script>

<style lang="scss" scoped>
  .reportWrapper {
    font-family: 'Open Sans', sans-serif !important;
    page-break-inside: avoid;
    .report-component-title {
      font-size: 40px;
      color: var(--itr-blue);
    }
    h4 {
      font-size: 20px;
      line-height: 1.3;
      font-weight: 800;
      color: var(--itr-blue);
      margin-bottom: 12px;
    }
    .margin-top {
      margin-top: 75px;
    }
    .report-component-section {
      color: var(--itr-blue);
      font-weight: bold;
      font-size: 26px;
    }
    .report-component-date {
      color: var(--itr-grey-charcoal);
      font-size: 22px;
      font-style: italic;
    }
    .centered {
      text-align: center;
      margin: 0 auto;
    }
    .overview {
      * {
        font-size: 18px !important;
        color: var(--itr-charcoal) !important;
        background-color: transparent !important;
        font-family: 'Open Sans', sans-serif !important;
      }
    }
    .about-text {
      font-size: 18px;
      color: var(--itr-charcoal);
      font-family: 'Open Sans', sans-serif;
    }
    .leading-indicator-image {
      text-align: center;
      img {
        max-width: 1000px;
        width: 100%;
        height: auto;
      }
    }
  }
</style>
